import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import AlocarEstudantesLayer from "../components/AlocarEstudantesLayer";
import { useTranslation } from "../i18n/I18nContext";

const AlocarEstudantesPage = () => {
  const { t } = useTranslation();
  return (
    <MasterLayout>
      <Breadcrumb title={t("turma.action.allocateStudents")} />
      <AlocarEstudantesLayer />
    </MasterLayout>
  );
};

export default AlocarEstudantesPage;
